import { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

import DetailsEventsModal from '../components/DetailsEventsModal/DetailsEventsModal';
import userRoles from '../security/constantsRols';
import { checkRol } from '../security';
import { getDetailsEventsFunctionAdapter } from '../adapters/monthlyRequestService/monthlyRequestService';
import { getDetailsEventsWeeklyReportFunctionAdapter } from '../adapters/weekly-report/events-operations-adapter';

import LoaderContext from './LoaderProvider';

export const DetailsEventsModalContext = createContext();
DetailsEventsModalContext.displayName = 'DetailsEventsModalContext';

const DetailsEventsModalProvider = ({ children }) => {
  const initialDataDetailsEventsModal = {
    details: []
  };
  const [showDetailsEventsModal, setShowDetailsEventsModal] = useState(false);
  const [dataDetailsEventsModal, setDataDetailsEventsModal] = useState(
    initialDataDetailsEventsModal
  );
  const [titleModal, setTitleModal] = useState('');
  const { loader, setLoader } = useContext(LoaderContext);

  const handleShowDetailsEventsModal = ({ showModal }) => {
    setShowDetailsEventsModal(showModal);
    setDataDetailsEventsModal(initialDataDetailsEventsModal);
  };

  const handleDataDetailsEventsModal = ({ details }) => {
    setDataDetailsEventsModal((prevState) => ({
      ...prevState,
      details
    }));
  };
  const handleTitleModal = ({ title }) => {
    setTitleModal(title);
  };

  const getDetailsEventsData = async ({ promiseFunction }) => {
    setLoader(true);
    try {
      const response = await promiseFunction;

      handleDataDetailsEventsModal({ details: response });
    } catch (error) {
      handleDataDetailsEventsModal({ details: [] });
    }
    setLoader(false);
  };
  const handleOperations = ({
    ubicationsData,
    requestData,
    isFromVE = false,
    isFromHeadRequest = false
  }) => {
    if (isFromVE || isFromHeadRequest) {
      getDetailsEventsData({
        promiseFunction: getDetailsEventsWeeklyReportFunctionAdapter(requestData.nroSolicitud)
      });
    } else
      getDetailsEventsData({
        promiseFunction: getDetailsEventsFunctionAdapter({
          idSolicitudMensualizada: Number(requestData.nroSolicitud),
          idUbicacion: ubicationsData.id
        })
      });
  };

  const handleHasTechnicalLocations = ({ headData }) =>
    // When hasTechnicalLocations is false this resquest is equipament tower
    (checkRol(userRoles.PROVEEDOR_NOTIFICADOR) || checkRol(userRoles.INSPECTOR)) &&
    !headData.tieneUbicacionesTecnicas;

  return (
    <DetailsEventsModalContext.Provider
      value={{
        showDetailsEventsModal,
        handleShowDetailsEventsModal,
        handleDataDetailsEventsModal,
        handleHasTechnicalLocations,
        handleOperations,
        handleTitleModal
      }}
    >
      {children}
      {!loader && showDetailsEventsModal && dataDetailsEventsModal?.details?.length && (
        <DetailsEventsModal
          dataDetailsEventsModal={dataDetailsEventsModal}
          handleShowDetailsEventsModal={handleShowDetailsEventsModal}
          showDetailsEventsModal={showDetailsEventsModal}
          titleModal={titleModal}
        />
      )}
    </DetailsEventsModalContext.Provider>
  );
};

DetailsEventsModalProvider.propTypes = {
  children: PropTypes.element.isRequired
};
export default DetailsEventsModalProvider;
